<div class="mb-4 text-lg font-semibold text-black">Email Notifications</div>
<div class="mb-4 text-xs text-aux-black">
  Choose the type of email alerts you would like to receive:
</div>

<div class="grid grid-cols-3 gap-10 whitespace-nowrap text-xs">
  <div class="space-y-6">
    <div class="space-y-3 rounded border p-6">
      <div class="flex justify-between">
        <strong>Period Close</strong>
        <aux-checkbox
          [checked]="isGroupChecked(notifications.periodClose)"
          [indeterminate]="isGroupIndeterminate(notifications.periodClose)"
          (customChange)="onGroupChange('periodClose')"
        />
      </div>
      <div class="flex justify-between">
        Reminder: Complete Checklist
        <aux-checkbox
          [(ngModel)]="notifications.periodClose.completeChecklistReminder.enabled"
          (customChange)="
            onChange([notifications.periodClose.completeChecklistReminder.event_type])
          "
        />
      </div>
      <div class="flex justify-between">
        Reminder: Upload Vendor Estimates
        <aux-checkbox
          [(ngModel)]="notifications.periodClose.uploadVendorEstimatesReminder.enabled"
          (customChange)="
            onChange([notifications.periodClose.uploadVendorEstimatesReminder.event_type])
          "
        />
      </div>
      <div class="flex justify-between">
        Investigator Data Ready for Review
        <aux-checkbox
          [(ngModel)]="notifications.periodClose.edcDocumentsReadyForReview.enabled"
          (customChange)="
            onChange([notifications.periodClose.edcDocumentsReadyForReview.event_type])
          "
        />
      </div>
      <div class="flex justify-between">
        Month Available to Close
        <aux-checkbox
          [(ngModel)]="notifications.periodClose.monthCloseAvailable.enabled"
          (customChange)="onChange([notifications.periodClose.monthCloseAvailable.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Month Closed
        <aux-checkbox
          [(ngModel)]="notifications.periodClose.monthClosed.enabled"
          (customChange)="onChange([notifications.periodClose.monthClosed.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Quarter Closed
        <aux-checkbox
          [(ngModel)]="notifications.periodClose.quarterClosed.enabled"
          (customChange)="onChange([notifications.periodClose.quarterClosed.event_type])"
        />
      </div>
    </div>
  </div>

  <div class="space-y-4">
    <div class="space-y-3 rounded border p-6">
      <div class="flex justify-between">
        <strong>Invoices</strong>
        <aux-checkbox
          [checked]="isGroupChecked(notifications.invoices)"
          [indeterminate]="isGroupIndeterminate(notifications.invoices)"
          (customChange)="onGroupChange('invoices')"
        />
      </div>
      <div class="flex justify-between">
        Reminder: Upload Invoices
        <aux-checkbox
          [(ngModel)]="notifications.invoices.uploadInvoicesReminder.enabled"
          (customChange)="onChange([notifications.invoices.uploadInvoicesReminder.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Pending Approval
        <aux-checkbox
          [(ngModel)]="notifications.invoices.pendingApproval.enabled"
          (customChange)="onChange([notifications.invoices.pendingApproval.event_type])"
        />
      </div>
    </div>

    <div class="space-y-3 rounded border p-6">
      <div class="flex justify-between">
        <strong>Change Orders</strong>
        <aux-checkbox
          [checked]="isGroupChecked(notifications.changeOrder)"
          [indeterminate]="isGroupIndeterminate(notifications.changeOrder)"
          (customChange)="onGroupChange('changeOrder')"
        />
      </div>
      <div class="flex justify-between">
        Change Order Request
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.request.enabled"
          (customChange)="onChange([notifications.changeOrder.request.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Change Order Request Confirmation
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.requestConfirmation.enabled"
          (customChange)="onChange([notifications.changeOrder.requestConfirmation.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Pending Review
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.pendingReview.enabled"
          [(ngModel)]="notifications.changeOrder.backToPendingReview.enabled"
          (customChange)="
            onChange([
              notifications.changeOrder.pendingReview.event_type,
              notifications.changeOrder.backToPendingReview.event_type,
            ])
          "
        />
      </div>
      <div class="flex justify-between">
        Pending Approval
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.pendingApproval.enabled"
          (customChange)="onChange([notifications.changeOrder.pendingApproval.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Approved
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.approved.enabled"
          (customChange)="onChange([notifications.changeOrder.approved.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Declined
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.declined.enabled"
          (customChange)="onChange([notifications.changeOrder.declined.event_type])"
        />
      </div>
      <div class="flex justify-between">
        Deleted
        <aux-checkbox
          [(ngModel)]="notifications.changeOrder.deleted.enabled"
          (customChange)="onChange([notifications.changeOrder.deleted.event_type])"
        />
      </div>
    </div>

    @if (authQuery.adminUser$ | async) {
      <div class="space-y-3 rounded border p-6">
        <div class="flex justify-between">
          <strong>Support</strong>
          <aux-checkbox
            [checked]="isGroupChecked(notifications.support)"
            [indeterminate]="isGroupIndeterminate(notifications.support)"
            (customChange)="onGroupChange('support')"
          />
        </div>
        <div class="flex justify-between">
          Automatic Budget Snapshot Failure
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailBudgetSnapshot.enabled"
            (customChange)="onChange([notifications.support.sendEmailBudgetSnapshot.event_type])"
          />
        </div>
        <div class="flex justify-between">
          Bulk Upload/Update POs
          <aux-checkbox
            [(ngModel)]="notifications.support.purchaseOrderBulkUploadNotification.enabled"
            (customChange)="
              onChange([notifications.support.purchaseOrderBulkUploadNotification.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Document(s) Uploaded
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailDocumentsUploaded.enabled"
            (customChange)="onChange([notifications.support.sendEmailDocumentsUploaded.event_type])"
          />
        </div>
        <div class="flex justify-between">
          EDC Document(s) Uploaded
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailEDCDocumentsUploaded.enabled"
            (customChange)="
              onChange([notifications.support.sendEmailEDCDocumentsUploaded.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Invoices Pending Review
          <aux-checkbox
            [(ngModel)]="notifications.support.invoicesPendingReview.enabled"
            (customChange)="onChange([notifications.support.invoicesPendingReview.event_type])"
          />
        </div>
        @if ((showRequestJournalEntryPreference$ | async) === true) {
          <div class="flex justify-between">
            Journal Entry Report Request
            <aux-checkbox
              [(ngModel)]="notifications.support.journalEntryReportRequested.enabled"
              (customChange)="
                onChange([notifications.support.journalEntryReportRequested.event_type])
              "
            />
          </div>
        }
        <div class="flex justify-between">
          Reminder: Categorize Invoices
          <aux-checkbox
            [(ngModel)]="notifications.support.invoiceCategorizationReminder.enabled"
            (customChange)="
              onChange([notifications.support.invoiceCategorizationReminder.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Site Contract Uploaded
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailSiteContractUploaded.enabled"
            (customChange)="
              onChange([notifications.support.sendEmailSiteContractUploaded.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Trial Protocol Uploaded
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailTrialProtocolUploaded.enabled"
            (customChange)="
              onChange([notifications.support.sendEmailTrialProtocolUploaded.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Updated Site Budget Effective Date
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailSiteBudgetEffectiveDateUpdated.enabled"
            (customChange)="
              onChange([notifications.support.sendEmailSiteBudgetEffectiveDateUpdated.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Vendor Contract Document(s) Uploaded
          <aux-checkbox
            [(ngModel)]="notifications.support.sendEmailVendorDocumentUploaded.enabled"
            (customChange)="
              onChange([notifications.support.sendEmailVendorDocumentUploaded.event_type])
            "
          />
        </div>
        <div class="flex justify-between">
          Vendor Estimate(s) Uploaded
          <aux-checkbox
            [(ngModel)]="notifications.support.vendorEstimateUploaded.enabled"
            (customChange)="onChange([notifications.support.vendorEstimateUploaded.event_type])"
          />
        </div>
      </div>
    }
  </div>
</div>

@if ((saveCheck$ | async)!) {
  <aux-save-changes
    [showDiscardChangesBtn]="true"
    [onSaveChanges]="saveChanges"
    (cancel)="reset()"
  />
}
